import { render, staticRenderFns } from "./SeoBreadcrumb.vue?vue&type=template&id=32de70ae&scoped=true"
import script from "./SeoBreadcrumb.vue?vue&type=script&lang=js"
export * from "./SeoBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./SeoBreadcrumb.vue?vue&type=style&index=0&id=32de70ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de70ae",
  null
  
)

export default component.exports